import clipboard from "clipboard-all";
import axios from 'axios'
export function formatData(data) {
  // console.log(data)
  let arr = [];
  if (data && data.length) {
    data.forEach(item => {
      arr.push(item);
      if (item.children && item.children.length) {
        item.children.forEach(child => {
          arr.push(child);
        });
      }
    });
  }
  // console.log(arr)
  return arr;
}

// 防抖函数
export function debounce(fn, wait) {
  if (wait == null || wait == undefined) {
    wait = 1200;
  }
  let timer = null;
  //  返回一个函数
  return function (...args) {
    // 每次触发事件时都取消之前的定时器
    clearTimeout(timer);
    // setTimeout中使用箭头函数，就是让 this指向 返回的该闭包函数，而不是 debounce函数的调用者
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
}

export function formatNum(value) {
  //过万处理
  let num = value;
  if (value > 9999) {
    //大于9999显示x.xx万
    num = Math.floor(value / 1000) / 10 + "w+";
  } else if (value < 9999 && value > 999) {
    num = Math.floor(value / 100) / 10 + "k+";
  } else if (value < -9999) {
    //小于-9999显示-x.xx万
    num = -(Math.floor(Math.abs(value) / 1000) / 10) + "w+";
  }
  return num;
}

/**
 *
 * @param {Array} arrs 树形数据
 * @param {string} childs 树形数据子数据的属性名,常用'children'
 * @param {Array} attrArr 需要提取的公共属性数组(默认是除了childs的全部属性)
 * @returns
 */
export function extractTree(arrs, childs, attrArr) {
  let attrList = [];
  if (!Array.isArray(arrs) && !arrs.length) return [];
  if (typeof childs !== "string") return [];
  if (!Array.isArray(attrArr) || (Array.isArray(attrArr) && !attrArr.length)) {
    attrList = Object.keys(arrs[0]);
    attrList.splice(attrList.indexOf(childs), 1);
  } else {
    attrList = attrArr;
  }
  let list = [];
  const getObj = arr => {
    arr.forEach(function (row) {
      let obj = {};
      attrList.forEach(item => {
        obj[item] = row[item];
      });
      list.push(obj);
      if (row[childs]) {
        getObj(row[childs]);
      }
    });
    return list;
  };
  return getObj(arrs);
}

// 一键复制
export async function oneClickCopy(e) {
  let res = await clipboard(e)
  return res
}


// base64转化为blob格式
export function b64toBlob(b64Data, contentType = null, sliceSize = null) {
  contentType = contentType || "image/png";
  sliceSize = sliceSize || 512;
  let byteCharacters = atob(b64Data);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: contentType });
}


export function downloadByAxios(url, name) {
  axios.get(url, {
    responseType: 'blob'
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'myfile.pdf');
    document.body.appendChild(link);
    link.click();
  });
}

export function downloadImage(src, name) {
  var image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'Anonymous')
  image.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height

    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL('image/png')
    console.log(url, 'url')
    // 生成一个a元素
    var a = document.createElement('a')
    // 创建一个单击事件
    var event = new MouseEvent('click')

    // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
    a.download = name || '下载图片名称'
    // 将生成的URL设置为a.href属性
    a.href = url

    // 触发a的单击事件
    a.dispatchEvent(event)
  }

  image.src = src
}

// 处理Id
export function extractIds(arr) {
  let filteredIds = arr.filter(item => item.auditStatus == 1).map(item => item.id);
  return filteredIds
}

// 判断是数字还是字符串
export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}

export function jsonSimpleClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

// 深拷贝对象
export function deepClone(obj) {
  const _toString = Object.prototype.toString

  // null, undefined, non-object, function
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  // DOM Node
  if (obj.nodeType && 'cloneNode' in obj) {
    return obj.cloneNode(true)
  }

  // Date
  if (_toString.call(obj) === '[object Date]') {
    return new Date(obj.getTime())
  }

  // RegExp
  if (_toString.call(obj) === '[object RegExp]') {
    const flags = []
    if (obj.global) {
      flags.push('g')
    }
    if (obj.multiline) {
      flags.push('m')
    }
    if (obj.ignoreCase) {
      flags.push('i')
    }

    return new RegExp(obj.source, flags.join(''))
  }

  const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {}

  for (const key in obj) {
    result[key] = deepClone(obj[key])
  }

  return result
}


/**
 * 表单json转换为后台需要的对象
 * @param item
 */
export function formItemConvertData(item, formKey) {
  const data = {
    type: item.typeId,
    formItemId: item.config.formId,
    label: item.config.label,
    // 转换字符串 防止报错
    defaultValue: _.isObject(item.config.defaultValue)
      ? JSON.stringify(item.config.defaultValue)
      : item.config.defaultValue,
    required: item.config.required,
    placeholder: removeHtmlTag(item.placeholder),
    regList: item.config.regList,
    showLabel: item.config.showLabel,
    span: item.config.span,
    displayType: item.config.displayType,
    hideType: item.config.hideType,
    scheme: item,
    formKey
  }
  return data
}

// uuid
export function uuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}



// WEBPACK FOOTER //
// ./src/utils/utils.js